import s from './IndustriesCardsBlockSlider.module.scss';
import {TIndustriesCardsBlockSliderProps} from "@/app/[locale]/common/components/IndustriesCardsBlockSlider/types";
import {Label} from "@/app/[locale]/common/components/Label/Label";
import {Line} from "@/app/[locale]/common/components/Line/Line";
import {SliderButtonsGroup} from "@/app/[locale]/common/components/SliderButtonsGroup/SliderButtonsGroup";
import {IndustriesCard} from "@/app/[locale]/common/components/Industries/IndustriesCard";
import {TIndustriesCardProps} from "@/app/[locale]/common/components/Industries/types";
import {IndustriesSlider} from "@/app/[locale]/common/components/Industries/IndustriesSlider/IndustriesSlider";

export const IndustriesCardsBlockSlider = ({ title, text, data }: TIndustriesCardsBlockSliderProps) => {
    return (
        <div className={s.industriesBlock}>
            <div className={`${s.industriesBlock_labelContainer}`}>
                <Label>{title}</Label>
                <Line className={s.industriesBlock_line}/>
                <div className={`${s.industriesBlock_buttonsContainer}`}>
                    <SliderButtonsGroup navigationId={'industriesBlock'}/>
                </div>
            </div>

            <p className={s.industriesBlock_text}>{ text }</p>

            <div className={s.industriesBlock_cardsContainer}>
                {
                    data.map((item: TIndustriesCardProps, index: number) => (
                        <IndustriesCard
                            key={index}
                            label={item.label}
                            text={item.text}
                            href={item.href}
                            image={item.image}
                        />
                    ))
                }
            </div>

            <div className={s.industriesBlock_slider}>
                <IndustriesSlider
                    data={data}
                    navigationId={'industriesBlock'}
                    renderSlide={(item, index) => (
                        <IndustriesCard
                            key={index}
                            label={(item as TIndustriesCardProps).label}
                            text={(item as TIndustriesCardProps).text}
                            href={(item as TIndustriesCardProps).href}
                            image={(item as TIndustriesCardProps).image}
                        />
                    )}
                />
            </div>
        </div>
    );
};